import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'zui-filter-icon',
  templateUrl: './filter-icon.component.html',
  styleUrls: ['./filter-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterIconComponent {

  @Input()
  active = false;

  @Input()
  disabled = false;

  @Input()
  titleText = '';

  @Output()
  resetTrigger = new EventEmitter<void>();

}
